import React, { useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import { toast } from 'react-toastify';
import { readString } from 'react-papaparse';
import MainLayout from '../components/MainLayout/MainLayout';
import './pages.css';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import { BASE_URL } from '../Config';

const MemberManagement = () => {
    const [activeSection, setActiveSection] = useState('');
    const [memberGroup, setMemberGroup] = useState([]);
    const [editingMember, setEditingMember] = useState({
        memberGroup: '',
        description: '',
    });
    const [editingForMember, setEditingMemberForMember] = useState({
        memberName: '',
        mobileNumber: '',
        memberGroup: '',
    });
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupForMember, setShowPopupForMember] = useState(false);
    const [members, setMembers] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [memberGroupFormData, setMemberGroupFormData] = useState({ memberGroup: '', description: '', });
    const [memberFormData, setMemberFormData] = useState({
        memberName: '',
        mobileNumber: '',
        memberGroup: '',
    });

    const fetchData = async () => {
        try {
            const memberGroupResponse = await fetch(`${BASE_URL}/api/members/memberGroup`, {
                method: "GET",
                headers: {
                    "wabaId": localStorage.getItem("WabaId"),
                    "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                },
            });
            const memberResponse = await fetch(`${BASE_URL}/api/members`, {
                method: "GET",
                headers: {
                    "wabaId": localStorage.getItem("WabaId"),
                    "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                },
            });

            const memberGroupData = await memberGroupResponse.json();
            const memberData = await memberResponse.json();

            setMemberGroup(memberGroupData);
            setMembers(memberData);
            console.log('memberGroup', memberGroupData);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handlememberGroupChange = (e) => {
        setMemberGroupFormData({ ...memberGroupFormData, [e.target.id]: e.target.value });
    };

    const handlememberChange = (e) => {
        setMemberFormData({ ...memberFormData, [e.target.id]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (activeSection === 'memberGroup') {
                const response = await fetch(`${BASE_URL}/api/members/memberGroup`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'wabaId': localStorage.getItem('WabaId'),
                        'phoneNumberId': localStorage.getItem('ClientPhoneNumberId'),
                    },
                    body: JSON.stringify(memberGroupFormData),
                });
                if (response.ok) {
                    toast.success('MemberGroup added successfully');
                    fetchData();
                } else {
                    const data = await response.json();
                    toast.error(`Error: ${data.error}`);
                }
            } else if (activeSection === 'members') {
                console.log('memberFormData', memberFormData);

                const response = await fetch(`${BASE_URL}/api/members`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'wabaId': localStorage.getItem('WabaId'),
                        'phoneNumberId': localStorage.getItem('ClientPhoneNumberId'),
                    },
                    body: JSON.stringify(memberFormData),
                });
                if (response.ok) {
                    toast.success('Member added successfully');
                    fetchData();
                } else {
                    const data = await response.json();
                    toast.error(`Error: ${data.error}`);
                }
            }
        } catch (error) {
            console.error('Error submitting form', error);
            toast.error('Failed to submit form. Please try again.');
        }
    };

    const handleEditClick = (memberGroup) => {
        setEditingMember(memberGroup);
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setEditingMember(null);
        setShowPopupForMember(false);
        setEditingMemberForMember(null);
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = async (e) => {
            const csvContent = e.target.result;
            let parsedData = readString(csvContent, { header: true }).data;

            parsedData = parsedData.filter(row => Object.values(row).some(value => value));

            if (parsedData.length === 0) {
                toast.error("No valid data to import.");
                return;
            }

            setCsvData(parsedData);

            try {
                const response = await fetch(`${BASE_URL}/api/members/bulk-insert`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'wabaId': localStorage.getItem('WabaId'),
                        'phoneNumberId': localStorage.getItem('ClientPhoneNumberId'),
                    },
                    body: JSON.stringify(parsedData),
                });
                if (response.ok) {
                    toast.success('CSV data imported successfully');
                    fetchData();
                } else {
                    toast.error('Failed to import CSV data');
                }
            } catch (error) {
                toast.error('Failed to import CSV data');
            }
        };

        if (file) reader.readAsText(file);
    };

    const handleInputChangeForEdit = (event) => {
        const { name, value } = event.target;
        setEditingMember((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    const handleSubmitForEdit = (event) => {
        event.preventDefault();
        console.log('hh', editingMember);

        fetch(`${BASE_URL}/api/members/memberGroup/editMemberGroup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(editingMember),
        })
            .then((response) => response.json())
            .then((data) => {
                fetchData();
                toast.success('MemberGroup edit successfully');
                console.log('Edit successful:', data);
                setTimeout(
                    handleClosePopup, 3000);
            })
            .catch((error) => {
                toast.error('Error at MemberGroup edit!');
                console.error('Error editing member group:', error);
            });
    };

    const handleDeleteClick = (memberGroup) => {
        const confirmDelete = window.confirm(
            `Are you sure you want to delete the group "${memberGroup.memberGroup}"?`
        );

        if (confirmDelete) {
            fetch(`${BASE_URL}/api/members/memberGroup/delete/${memberGroup._id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response.ok) {
                        console.log(`Deleted group: ${memberGroup.memberGroup}`);
                        toast.success(`Deleted group: ${memberGroup.memberGroup}`);
                        fetchData();
                    } else {
                        toast.error(`Error At Deleted group: ${memberGroup.memberGroup}`);
                        return response.json().then((error) => {
                            throw new Error(error.message);
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error deleting group:', error);
                });
        }
    };


    const csvHeaders = [
        { label: 'memberName', key: 'memberName' },
        { label: 'mobileNumber', key: 'mobileNumber' },
        { label: 'memberGroup', key: 'memberGroup' },
    ];

    async function downloadMemberData() {
        try {
            const response = await fetch(`${BASE_URL}/api/members`, {
                method: "GET",
                headers: {
                    "wabaId": localStorage.getItem("WabaId"),
                    "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                },
            });
            if (!response.ok) {
                throw new Error('Failed to fetch members data');
            }
            const data = await response.json();
            const transformedData = data.map(member => ({
                ...member,
                memberGroup: member.memberGroup.memberGroup,
            }));
            const csv = Papa.unparse(transformedData, {
                header: true,
                skipEmptyLines: true,
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, 'members.csv');
        } catch (error) {
            console.error('Error downloading member data:', error);
        }
    }

    const handleEditClickForMember = (member) => {
        setEditingMemberForMember(member);
        setShowPopupForMember(true);
    };


    const handleInputChangeForEditForMember = (event) => {
        const { name, value } = event.target;
        setEditingMemberForMember((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const handleInputChangeForEditForSelect = (event) => {
        const { name, value } = event.target;

        setEditingMemberForMember((prevState) => ({
            ...prevState,
            [name]: name === 'memberGroup' ? { _id: value } : value,
        }));
    };

    const handleSubmitForEditForMember = (event) => {
        event.preventDefault();
        console.log('hh', editingForMember);

        // Call the API to edit the member group
        fetch(`${BASE_URL}/api/members/editMember`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(editingForMember),
        })
            .then((response) => response.json())
            .then((data) => {
                // Handle successful response
                fetchData();
                toast.success('Member edit successfully');
                console.log('Edit successful:', data);
                setTimeout(
                    handleClosePopup, 3000);

                // Optionally close popup or reset state
            })
            .catch((error) => {
                toast.error('Error at Member edit!');
                console.error('Error editing member :', error);
            });
    };

    const handleDeleteClickForMember = (member) => {
        const confirmDelete = window.confirm(
            `Are you sure you want to delete the member "${member.memberName}"?`
        );

        if (confirmDelete) {
            fetch(`${BASE_URL}/api/members/delete/${member._id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response.ok) {
                        console.log(`Deleted member: ${member.memberName}`);
                        toast.success(`Deleted member: ${member.memberName}`);
                        fetchData();
                    } else {
                        toast.error(`Error At Deleted member: ${member.memberName}`);
                        return response.json().then((error) => {
                            throw new Error(error.message);
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error deleting member:', error);
                });
        }
    };

    return (
        <MainLayout>
            <div style={{ padding: '20px', marginTop: '32px' }}>
                <div className='body'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }} >
                        <button
                            className={`submitButton ${activeSection === 'memberGroup' ? 'active' : ''}`}
                            style={{ width: '50%' }}
                            onClick={() => { setActiveSection('memberGroup'); handleClosePopup(); }}
                        >
                            Member Group
                        </button>
                        <button
                            className={`submitButton ${activeSection === 'members' ? 'active' : ''}`}
                            style={{ width: '50%' }}
                            onClick={() => { setActiveSection('members'); handleClosePopup(); }}
                        >
                            Member
                        </button>
                        <button
                            className={`submitButton ${activeSection === 'exportImport' ? 'active' : ''}`}
                            style={{ width: '50%' }}
                            onClick={() => {
                                setActiveSection('exportImport');
                                handleClosePopup();
                            }}
                        >
                            export Import
                        </button>
                    </div>

                    {activeSection === 'memberGroup' && (
                        <div className="body">
                            <form onSubmit={handleSubmit} className="formStyle">
                                <h3>Create MemberGroup</h3>
                                <div className="form-group">

                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <label style={{ alignSelf: 'center' }} htmlFor="MemberGroup">MemberGroup Name</label>
                                        <input
                                            type="text"
                                            id="memberGroup"
                                            value={memberGroupFormData.memberGroup}
                                            onChange={handlememberGroupChange}
                                            placeholder="Enter memberGroup Name"
                                            style={{ width: '70%' }}
                                        />
                                        <label style={{ alignSelf: 'center' }} htmlFor="description">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            value={memberGroupFormData.description}
                                            onChange={handlememberGroupChange}
                                            placeholder="Enter memberGroup description"
                                            style={{ width: '70%' }}
                                        />
                                        <button className="submitButton" type="submit">Add MemberGroup</button>
                                    </div>
                                </div>
                            </form>

                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#0077b6', color: 'white' }}>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>ID</th>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>MemberGroup Name</th>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>Discription</th>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>No. Of Records</th>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {memberGroup.map((memberGroup) => (
                                        <tr key={memberGroup._id}>
                                            <td style={{ padding: '10px', textAlign: 'Center' }}>{memberGroup._id}</td>
                                            <td style={{ padding: '10px', textAlign: 'Center' }}>{memberGroup.memberGroup}</td>
                                            <td style={{ padding: '10px', textAlign: 'Center' }}>{memberGroup.description}</td>
                                            <td style={{ padding: '10px', textAlign: 'Center' }}>{memberGroup.memberCount}</td>
                                            <td style={{ padding: '10px', textAlign: 'Center', display: 'flex', gap: '5px' }}>
                                                <button style={{ padding: '6px 18px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
                                                    onClick={() => handleEditClick(memberGroup)}>Edit</button>
                                                <button
                                                    style={{ padding: '6px 18px', background: 'red', color: '#fff', border: 'none', borderRadius: '5px' }}
                                                    onClick={() => handleDeleteClick(memberGroup)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {activeSection === 'members' && (
                        <div className="body">
                            <form onSubmit={handleSubmit} className="formStyle">
                                <h3>Create Member</h3>
                                <div className="formRow">
                                    <div className="form-group">
                                        <label htmlFor="memberGroup">MemberGroup</label>
                                        <select
                                            id="memberGroup"
                                            value={memberFormData.memberGroup}
                                            onChange={handlememberChange}
                                            className='formInput'
                                            style={{ height: '31px', width: '100%' }}
                                        >
                                            <option value="">Select MemberGroup</option>
                                            {memberGroup.map((memberGroup) => (
                                                <option key={memberGroup._id} value={memberGroup._id}>
                                                    {memberGroup.memberGroup}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="MemberName">Member Name</label>
                                        <input
                                            type="text"
                                            id="memberName"
                                            value={memberFormData.memberName}
                                            onChange={handlememberChange}
                                            placeholder="Enter Member Name"
                                            className='formInput'
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="MobileNumber">MobileNumber</label>
                                        <input
                                            type="text"
                                            id="mobileNumber"
                                            value={memberFormData.mobileNumber}
                                            onChange={handlememberChange}
                                            placeholder="Enter MobileNumber"
                                            className='formInput'
                                        />
                                    </div>
                                </div>
                                <button style={{ margin: '10px 36% 0 43%' }} className="submitButton" type="submit">Add Member</button>
                            </form>

                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#0077b6', color: 'white' }}>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>Member Name</th>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>Mobile Number</th>
                                        <th style={{ padding: '10px', textAlign: 'Center' }}>MemberGroup Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {members.map((member) => (
                                        <tr key={member._id}>
                                            <td style={{ textAlign: 'Center' }}>{member.memberName}</td>
                                            <td style={{ textAlign: 'Center' }}>{member.mobileNumber}</td>
                                            <td style={{ textAlign: 'Center' }}>{member.memberGroup?.memberGroup || 'No Group'}</td>
                                            <td style={{ padding: '10px', textAlign: 'Center', display: 'flex', gap: '5px' }}>
                                                <button style={{ padding: '6px 18px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
                                                    onClick={() => handleEditClickForMember(member)}>Edit</button>
                                                <button
                                                    style={{ padding: '6px 18px', background: 'red', color: '#fff', border: 'none', borderRadius: '5px' }}
                                                    onClick={() => handleDeleteClickForMember(member)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {activeSection === 'exportImport' && (
                        <div className="body">
                            <h3 style={{ marginTop: '30px' }}>Export / Import Members</h3>

                            <div className="csv-actions">
                                <div className="csv-upload">
                                    <label htmlFor="csv-upload" className="upload-label">Import Member Data</label>
                                    <input
                                        id="csv-upload"
                                        type="file"
                                        accept=".csv"
                                        onChange={handleFileUpload}
                                        className="file-input"
                                    />
                                </div>

                                <button
                                    className="submitButton"
                                    onClick={downloadMemberData}
                                >
                                    Download Members Data
                                </button>
                            </div>

                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                                <thead>
                                    <tr>
                                        {csvHeaders.map((header) => (
                                            <th key={header.key} style={{ padding: '10px', backgroundColor: '#0077b6', color: 'white' }}>
                                                {header.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {csvData.map((row, index) => (
                                        <tr key={index}>
                                            {csvHeaders.map((header) => (
                                                <td key={header.key} style={{ padding: '10px' }}>
                                                    {row[header.key]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {showPopup && (
                        <div className="popup-overlayForLicense">
                            <div className="popup-contentForLicense">
                                <div style={{ marginLeft: '39px' }}>
                                    <form style={{ width: '60%', marginTop: '-20%', zIndex: '1', position: 'fixed' }} onSubmit={handleSubmitForEdit} className="formStyle">
                                        <h3>Edit MemberGroup</h3>
                                        <div className="form-group">

                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <div>
                                                    <label style={{ alignSelf: 'center' }} htmlFor="MemberGroup">MemberGroup Name</label>
                                                    <input
                                                        type="text"
                                                        id="memberGroup"
                                                        name="memberGroup"
                                                        value={editingMember.memberGroup}
                                                        onChange={handleInputChangeForEdit}
                                                        placeholder="Enter memberGroup Name"
                                                        style={{ width: '70%', height: '23px' }}
                                                    />
                                                </div>
                                                <div>
                                                    <label style={{ alignSelf: 'center' }} htmlFor="description">Description</label>
                                                    <input
                                                        type="text"
                                                        id="description"
                                                        name="description"
                                                        value={editingMember.description || ''}
                                                        onChange={handleInputChangeForEdit}
                                                        placeholder="Enter Description"
                                                        style={{ width: '70%', height: '23px' }}
                                                    />
                                                </div>
                                                <button className="submitButton" type="submit">Edit MemberGroup</button>

                                                <button style={{ padding: '10px 20px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '5px', marginLeft: '2px' }} onClick={handleClosePopup}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    )}


                    {showPopupForMember && (
                        <div className="popup-overlayForLicense">
                            <div className="popup-contentForLicense">
                                <div style={{ marginLeft: '39px' }}>
                                    <form style={{ width: '60%', marginTop: '-20%', zIndex: '1', position: 'fixed' }} onSubmit={handleSubmitForEditForMember} className="formStyle">
                                        <h3>Edit Member</h3>
                                        <div className="form-group">

                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <div>
                                                    <label style={{ alignSelf: 'center' }} htmlFor="MemberGroup">MemberGroup Name</label>
                                                    <select
                                                        id="memberGroup"
                                                        name="memberGroup"
                                                        value={editingForMember.memberGroup?._id || ''}
                                                        onChange={handleInputChangeForEditForSelect}
                                                        className="formInput"
                                                        style={{ height: '31px', width: '100%' }}
                                                    >
                                                        <option value="">Select MemberGroup</option>
                                                        {memberGroup.map((group) => (
                                                            <option key={group._id} value={group._id}>
                                                                {group.memberGroup}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div>
                                                    <label style={{ alignSelf: 'center' }} htmlFor="memberName">memberName</label>
                                                    <input
                                                        type="text"
                                                        id="memberName"
                                                        name="memberName"
                                                        value={editingForMember.memberName || ''}
                                                        onChange={handleInputChangeForEditForMember}
                                                        placeholder="Enter memberName"
                                                        style={{ width: '70%', height: '23px' }}
                                                    />
                                                </div>
                                                <div>
                                                    <label style={{ alignSelf: 'center' }} htmlFor="mobileNumber">mobileNumber</label>
                                                    <input
                                                        type="text"
                                                        id="mobileNumber"
                                                        name="mobileNumber"
                                                        value={editingForMember.mobileNumber || ''}
                                                        onChange={handleInputChangeForEditForMember}
                                                        placeholder="Enter mobileNumber"
                                                        style={{ width: '70%', height: '23px' }}
                                                    />
                                                </div>
                                                <button className="submitButton" type="submit">Edit Member</button>

                                                <button style={{ padding: '10px 20px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '5px', marginLeft: '2px' }}
                                                    onClick={handleClosePopup}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </MainLayout>
    );
};

export default MemberManagement;
